var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapsPhotosScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.google{fill:url(#google-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaceff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36069,
    stopColor: "#5998f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3c85f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3369cb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "google",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M32.07373,70.4248h35.85254c2.48145,0,4.5-2.01855,4.5-4.5v-26.88428c0-2.48145-2.01855-4.5-4.5-4.5h-21.71997c.0166-.15424.03192-.3078.03192-.45276,0-4.42865-3.59009-8.0188-8.0188-8.0188s-8.0188,3.59015-8.0188,8.0188c0,.25909.03632.53851.08801.82605-1.59491.69269-2.7149,2.27985-2.7149,4.12671v26.88428c0,2.48145,2.01855,4.5,4.5,4.5ZM38.21942,30.83014c1.79919,0,3.25763,1.4585,3.25763,3.25763s-1.45844,3.25763-3.25763,3.25763-3.25763-1.45844-3.25763-3.25763,1.4585-3.25763,3.25763-3.25763ZM36.14838,45.01251c1.05994,1.33258,3.08221,1.33258,4.14209,0,1.59033-1.99933,3.71167-4.89093,4.94385-7.47198h22.69196c.82715,0,1.5.67285,1.5,1.5v21.62488l-6.84296-6.84296c-1.02344-1.02344-2.6828-1.02344-3.70624,0l-6.2652,6.2652-9.32007-9.32007c-1.0235-1.02344-2.6828-1.02344-3.7063,0l-9.01178,9.01184v-20.73889c0-.54718.29755-1.02185.73627-1.28387,1.24512,2.52527,3.29224,5.31207,4.83838,7.25586Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "white",
    cx: 52.51489,
    cy: 44.76434,
    r: 3.42609
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapsPhotosScraper);
export default __webpack_public_path__ + "static/media/google-maps-photos-scraper.e548f3e7910e7d1acc10156d45f5391f.svg";
export { ForwardRef as ReactComponent };